import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

/**
 * 시간을 원하는 string 포맷으로 변환한다
 */
export function dateToString(date: Date, format: string) {
  return dayjs(date).tz('Asia/Seoul').format(format);
}

/**
 * string 포맷의 날짜를 Date 객체로 변환한다
 */
export function stringToDate(dateString: string, format: string) {
  return dayjs(dateString, format).tz('Asia/Seoul').toDate();
}

/**
 * 넣어준 Date 객체에서 주어진 개월 수를 뺀 Date 객체를 반환한다
 */
export function subtractMonth(date: Date, month: number) {
  return dayjs(date).add(-month, 'month').toDate();
}

/**
 * 넣어준 YYYYmmDDhhMMss 형식의 String 에서 YYYY-MM-DD hh:MM 형식의 String 으로 반환한다
 */
export function stringToDateFormat(dateString: string) {
  return (
    dateString.substring(0, 4) +
    '-' +
    dateString.substring(4, 6) +
    '-' +
    dateString.substring(6, 8) +
    ' ' +
    dateString.substring(8, 10) +
    ':' +
    dateString.substring(10, 12)
  );
}
